import LandaFinancingFAQBox from 'pages/lend/components/LandaFinancingFAQ/components/LandaFinancingFAQBox';
import { FAQ } from 'pages/lend/components/LandaFinancingFAQ/utils';
import React from 'react';
import { DebtType } from 'types/debt-types';

const LandaFinancingFAQ = ({ debt }: { debt: DebtType }) => {
  return (
    <>
      {FAQ.map((item, index) => (
        <LandaFinancingFAQBox
          debt={debt}
          question={item?.question}
          answer={item?.answer}
          answerComponent={item?.answerComponent?.(debt)}
          key={index}
        />
      ))}
    </>
  );
};

export default LandaFinancingFAQ;
